import { render, staticRenderFns } from "./StudentWarn1.vue?vue&type=template&id=afa25880&scoped=true"
import script from "./StudentWarn1.vue?vue&type=script&lang=js"
export * from "./StudentWarn1.vue?vue&type=script&lang=js"
import style0 from "./StudentWarn1.vue?vue&type=style&index=0&id=afa25880&scoped=true&lang=css"
import style1 from "./StudentWarn1.vue?vue&type=style&index=1&id=afa25880&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa25880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afa25880')) {
      api.createRecord('afa25880', component.options)
    } else {
      api.reload('afa25880', component.options)
    }
    module.hot.accept("./StudentWarn1.vue?vue&type=template&id=afa25880&scoped=true", function () {
      api.rerender('afa25880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StudentWarn1.vue"
export default component.exports